<template>
    <div class="container" :style="containerStyle">
        <CameraComponent :moduleData="moduleData" :activeEvent="activeEvent" :photoboothAccessToken="photoboothAccessToken" v-if="moduleData" @togglePulse="pulsing = !pulsing" id="cameraComponent" />
        <img id="background" class="background" v-if="frame != ''">
        <section id="cameraArrows" data-html2canvas-ignore>
            <img :class="{ 'pulsate': pulsing }" src="../src/assets/media/icon_2000x2000_SMILE.png">
        </section>
        <article id="a-images">
            <section id="s-images">
                <div id="d-logo_left">
                    <img id="logo_left" onerror="this.outerHTML=''"/>
                </div>
                <div id="d-logo_right">
                    <img id="logo_right" onerror="this.outerHTML=''"/>
                </div>
            </section>
        </article>
    </div>
</template>

<script>
import CameraComponent from './components/CameraComponent.vue'
import authService from "@/mixins/authService";

export default {
    name: 'App',

    components: {
        CameraComponent
    },

    data() {
        return {
            bgColor: "#000000",
            frame: null,
            moduleData: null,
            activeEvent: null,
            accessToken: null,
            photoboothAccessToken: null,
            logos: ['logo_left', 'logo_right'],
            pulsing: false
        }
    },

    computed: {
        containerStyle() {
            return {
                backgroundColor: this.bgColor
            }
        },
    },

    mixins: [
        authService
    ],

    async created() {
        this.bgColor = window._settings.bgColor

        const { serviceUrl, apiId, apiKey, photoboothApiHost, photoboothApiId, photoboothApiKey } = window._settings;
        const tokenData = await this.getToken(`${serviceUrl}/oauth/token`, apiId, apiKey);
        const photoboothTokenData = await this.getToken(`${photoboothApiHost}/oauth/token`, photoboothApiId, photoboothApiKey);
        this.accessToken = `Bearer ${tokenData.access_token}`;
        this.photoboothAccessToken = `Bearer ${photoboothTokenData.access_token}`;
        this.moduleData = await this.getOculariumModuleData();
        this.activeEvent = await this.getActiveEvent();

        let el = document.querySelector('#s-images');

        if (this.moduleData.json.isXXLWall) {
            el.id = 's-images-xxl';
        } else {
            document.querySelector('#cameraArrows img').style.marginTop = '5.5%';
            el.id = 's-images-16';
        }

        el.classList.add('normal');

        if(this.moduleData.json.useRoundSquareLayout) {
            el.classList.remove('normal');
            el.classList.add('roundSquare');
        }

        for (let logo of this.logos) {
            const path = this.moduleData.json[logo].path;
            if (!path) {
                console.error(`Missing path for ${logo}`);
                document.querySelector(`#${logo}`).outerHTML = '';
                continue;
            }

            this.getImage(path, logo);
        }

        this.frame = this.moduleData.json.background.path;
        this.getImage(this.frame, 'background');
    },

    methods: {
        async getImage(path, logo_id) {
            if (!path) {
                return null;
            }

            const response = await fetch(`${window._settings.proxyUrl}/image`, {
                method: 'POST',
                body: JSON.stringify({
                    "path": path
                })
            })
            const data = await response.blob()
            const objectURL = URL.createObjectURL(data);
            const img = document.getElementById(logo_id);
            img.src = objectURL;
        },

        async getOculariumModuleData() {
            const urlParams = new URLSearchParams(window.location.search);
            const moduleId = urlParams.get('moduleid');
            if (!moduleId) {
                console.error('No module id found');
                return;
            }

            const url = `${window._settings.serviceUrl}/api/v2/modules/${moduleId}/settings`;
            let response = await fetch(url, {
                headers: {
                    'Authorization': this.accessToken
                },
            });

            const data = await response.json();
            const { background, emailAddress } = data.json;
            if (!background.path || !emailAddress) {
                console.error('Missing data');
                return;
            }

            return data;
        },

      async getActiveEvent() {
        const urlParams = new URLSearchParams(window.location.search);
        const moduleId = urlParams.get('moduleid');
        if (!moduleId) {
          console.error('No module id found');
          return;
        }

        const url = `${window._settings.photoboothApiHost}/api/v1/events/search`;
        let response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': this.photoboothAccessToken
          },
          body: JSON.stringify({
            xperify_module_id: parseInt(moduleId)
          })
        });

        const data = await response.json();

        const now = Date.now()
        const events = data.data;
        let activeEvent = null;

        for (let i = 0; i < events.length; i++) {
          if (now >= Date.parse(events[i].start) && now <= Date.parse(events[i].end)) {
            if (events[i].xperifyModuleId === parseInt(moduleId)) {
              activeEvent = events[i];
              break;
            }
          }
        }

        return activeEvent;
      },
    }
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100vw;
    height: 100vh;
}

.container {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
}

#cameraArrows {
    position: absolute;
    top: 0;
    width: 47vw;
    text-align: end;
    left: 0;
    font-size: 5rem;
    z-index: 10000;
}

#cameraArrows>img {
    width: auto;
    height: 9vh;
    margin-top: 18px;
}

#a-images {
    position: absolute;
    pointer-events: none;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
}

#s-images-16.roundSquare {
    height: 16vh;
    margin-top: 1vh;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-around;
    flex-direction: row;

    #d-logo_left, #d-logo_right {
        display:flex;
        justify-content: center;
        width: 18%;
        img {
            height: auto;
            object-fit: scale-down;
            width: 100%;
        }
    }
}

#s-images-16.normal {
    height: 17.5vh;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-around;
    flex-direction: row;

    #d-logo_left, #d-logo_right {
        display:flex;
        justify-content: center;
        width: 18%;
        img {
            height: auto;
            object-fit: scale-down;
            width: 100%;
        }
    }
}

#s-images-xxl.normal {
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;

    #d-logo_left, #d-logo_right {
        img {
            width: 1920px;
            height: 720px;
            max-width: 1920px;
            max-height: 700px;
            object-fit: contain;
            object-position: center center;
        }
    }

    #d-logo_left {
        margin-left: 195px;
    }

    #d-logo_right {
        margin-right: 195px;
    }
}

#s-images-xxl.roundSquare {
    height: 100%;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;

    #d-logo_left, #d-logo_right {
        img {
            width: 670px;
            height: 670px;
            max-width: 670px;
            max-height: 670px;
            object-fit: contain;
            object-position: center center;
        }
    }

    #d-logo_left {
        margin-left: 1330px;
    }

    #d-logo_right {
        margin-right: 1330px;
    }
}


.pulsate {
    animation: pulse 1s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(.85);
    }

    50% {
        transform: scale(1);
        box-shadow: 0 0 0 50px rgba(90, 153, 212, 0);
    }

    100% {
        transform: scale(0.85);
        box-shadow: 0 0 0 0 rgba(90, 153, 212, 0);
    }
}

* {
    overflow: hidden;
}
</style>
